import {SAMPLE_TYPES_CODES} from "../../utils/constants";
import {ColiformInfo, OtherInfo, DAIRY_COMP_CODES} from "./DairyCompConstants";
import {GetCodesFromSampleComments} from "./DairyCompHelpers";

const CheckForColiforms = (comments) => {
	if(!comments){
		return
	}
	return GetCodesFromSampleComments(ColiformInfo, comments)
}

// Check sample_comments for any words below
const CheckForOtherOrganisms = (comments) => {
	if(!comments){
		return
	}
	return GetCodesFromSampleComments(OtherInfo, comments)
}

export default function DownloadAsDairyComp(samples){
	if(samples.length === 0){
		return
	}
	
	if(
		samples[0].sample_type === SAMPLE_TYPES_CODES.comp ||
		samples[0].sample_type === SAMPLE_TYPES_CODES.bulk
	){
		return
	}
	
	let fileData = samples.map(sample => {
		return SampleToDairyComp(sample)
	}).join("\n")
	
	const blob = new Blob([fileData], { type: 'text/text' })
	
	let link = document.createElement("a")
	
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `HERDCODE.dnq`)
	} else {
		link.setAttribute('href', URL.createObjectURL(blob))
		link.setAttribute('download', `HERDCODE.dnq`)
		link.click()
	}
}

const SampleToDairyComp = sample => {
	let sampleDate = sample.sample_date.replaceAll('-', '/')
	let cowID = sample.binary_cow_id ?? '0000'
	
	let results = []
	
	if(sample.binary_nsg){
		results.push(DAIRY_COMP_CODES.NO_GROWTH)
	}
	
	if(sample.staph_aureus){
		results.push(DAIRY_COMP_CODES.STAPH_AUREUS)
	}
	
	if(sample.strep_ag){
		results.push(DAIRY_COMP_CODES.STEP_AG)
	}
	
	if(sample.staph_other){
		results.push(DAIRY_COMP_CODES.STAPH_OTHER)
	}
	
	if(sample.strep_other){
		results.push(DAIRY_COMP_CODES.STREP_OTHER)
	}
	
	if(sample.coliform){
		let coliformCodes = CheckForColiforms(sample.sample_comments)
		
		if(coliformCodes && coliformCodes.length > 0){
			results = results.concat(coliformCodes)
		}
	}
	
	if(sample.other){
		let otherCodes = CheckForOtherOrganisms(sample.sample_comments)
		
		if(otherCodes && otherCodes.length > 0){
			results = results.concat(otherCodes)
		}else{
			results.push(DAIRY_COMP_CODES.OTHER)
		}
	}
	
	if(sample.binary_day4 || sample.binary_day7){
		results.push(DAIRY_COMP_CODES.MYCO)
	}
	
	let optionalQuarter = ''
	
	if(sample.sample_type === SAMPLE_TYPES_CODES.solo) {
		const SOLO_OPTIONS = [
			"LF",
			"RF",
			"LH",
			"RH",
			"CS",
			"IN",
			"OK",
			"DO"
		]
		
		if(sample.individual_sample_type) {
			if (SOLO_OPTIONS.includes(sample.individual_sample_type.toUpperCase())) {
				optionalQuarter = sample.individual_sample_type.toUpperCase()
			}
		}
	}
	
	if(sample.sample_comments){
		const contaminatedRegex = /contaminated/
		
		if(contaminatedRegex.test(sample.sample_comments.toLowerCase())){
			results = ['X']
		}
	}
	
	return `${sampleDate} ${cowID} ${results.join(',')} ${optionalQuarter}`
}